import { BigDecimal } from 'bigdecimal'

// 大数相乘
export const multiply = (a, b) => {
  if (!a || !b) return new BigDecimal('0')
  const value1 = new BigDecimal(a.toString())
  const value2 = new BigDecimal(b.toString())
  return value1.multiply(value2)
}

// 四舍五入
export const roundUp = (num, digits) => {
  return num
    .setScale(digits, BigDecimal.ROUND_HALF_DOWN)
    ?.toString()
    ?.replace(/\.?0+$/, '') // 去掉末尾.000的情况
}
